// Square 14px checkbox with its label (DESIGN_SPEC §10.7). Never a toggle switch.
//   <Check checked onChange count? disabled? className? title?>Hide OS background</Check>   count renders faint after the label
import type { ReactNode } from "react";
import { cx } from "./cx";

export function Check({
  checked,
  onChange,
  count,
  disabled,
  className,
  title,
  children,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  count?: ReactNode;
  disabled?: boolean;
  className?: string;
  title?: string;
  children: ReactNode;
}) {
  return (
    <label className={cx("check", disabled && "cursor-default opacity-45", className)} title={title}>
      <input type="checkbox" className="disabled:cursor-default" checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />
      {children}
      {count !== undefined && count !== null && <span className="faint">{count}</span>}
    </label>
  );
}
